import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/socialAccountPage.scss";

/**
 * SocialAccountPage — Manage social account connections
 * Figma: Social Account management
 *
 * Layout:
 *   - Navbar
 *   - Breadcrumb: "Setting › Social account"
 *   - Card with:
 *     - Title: "Social account"
 *     - Google row: disconnect button + email + menu
 *     - Divider
 *     - Facebook row: connect button + external link icon
 *   - Footer
 */

const SocialAccountPage = () => {
  const navigate = useNavigate();
  const [googleConnected, setGoogleConnected] = useState(true);
  const [facebookConnected, setFacebookConnected] = useState(false);

  const handleGoogleDisconnect = () => {
    setGoogleConnected(false);
  };

  // eslint-disable-next-line no-unused-vars
  const handleGoogleConnect = () => {
    setGoogleConnected(true);
  };

  const handleFacebookConnect = () => {
    setFacebookConnected(true);
  };

  return (
    <div className="social-account-page">
      <Navbar activeTab="" />

      <div className="social-account-page__body">
        {/* Breadcrumb */}
        <div className="social-account-page__breadcrumb">
          <span className="social-account-page__breadcrumb-link" onClick={() => navigate("/settings")} style={{ cursor: "pointer" }}>
            Setting
          </span>
          <span className="social-account-page__breadcrumb-sep">›</span>
          <span className="social-account-page__breadcrumb-current">Social account</span>
        </div>

        {/* Card */}
        <div className="social-account-page__card">
          <h2 className="social-account-page__card-title">Social account</h2>

          {/* Google row */}
          <div className="social-account-page__row">
            <div className="social-account-page__icon-wrapper">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                className="social-account-page__google-icon"
              >
                <circle cx="16" cy="16" r="14" fill="#fff" stroke="#e5e5e5" strokeWidth="1" />
                <text
                  x="16"
                  y="18"
                  textAnchor="middle"
                  fontFamily="Arial, sans-serif"
                  fontSize="18"
                  fontWeight="600"
                  fill="#4285f4"
                >
                  G
                </text>
              </svg>
            </div>

            <div className="social-account-page__account-info">
              <span
                className="social-account-page__account-action"
                style={{ color: googleConnected ? "#ef4444" : "#10b981" }}
              >
                {googleConnected ? "Disconnect account" : "Connect Google"}
              </span>
            </div>

            {googleConnected && (
              <div className="social-account-page__account-details">
                <span className="social-account-page__email">dean@youremail.com</span>
                <button className="social-account-page__menu-btn">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="4" r="1.5" fill="currentColor" />
                    <circle cx="10" cy="10" r="1.5" fill="currentColor" />
                    <circle cx="10" cy="16" r="1.5" fill="currentColor" />
                  </svg>
                </button>
              </div>
            )}

            {!googleConnected && (
              <button
                className="social-account-page__connect-btn"
                onClick={handleGoogleDisconnect}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 13L13 3M13 3H7M13 3V9"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            )}
          </div>

          {/* Divider */}
          <div className="social-account-page__divider"></div>

          {/* Facebook row */}
          <div className="social-account-page__row">
            <div className="social-account-page__icon-wrapper">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                className="social-account-page__facebook-icon"
              >
                <circle cx="16" cy="16" r="14" fill="#1877f2" />
                <text
                  x="16"
                  y="19"
                  textAnchor="middle"
                  fontFamily="Arial, sans-serif"
                  fontSize="20"
                  fontWeight="900"
                  fill="white"
                >
                  f
                </text>
              </svg>
            </div>

            <div className="social-account-page__account-info">
              <span
                className="social-account-page__account-action"
                style={{ color: facebookConnected ? "#ef4444" : "white" }}
              >
                {facebookConnected ? "Disconnect account" : "Connect Facebook"}
              </span>
            </div>

            {!facebookConnected && (
              <button
                className="social-account-page__connect-btn"
                onClick={handleFacebookConnect}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 13L13 3M13 3H7M13 3V9"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            )}

            {facebookConnected && (
              <button className="social-account-page__menu-btn">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="10" cy="4" r="1.5" fill="currentColor" />
                  <circle cx="10" cy="10" r="1.5" fill="currentColor" />
                  <circle cx="10" cy="16" r="1.5" fill="currentColor" />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SocialAccountPage;
